export function mergeObjects(baseConfig, targetConfigUSA, targetConfigCanada, countryCode) {
  baseConfig.countryCode = countryCode;
  if (countryCode === 'CAN') {
    baseConfig = {...baseConfig, ...targetConfigCanada};
  }
  if (countryCode === 'USA') {
    baseConfig = {...baseConfig, ...targetConfigUSA};
  }

  return baseConfig;
}
